var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Basic = require("../../../elements/Basic");

var _Fontello = _interopRequireDefault(require("../../../utilities/Fontello"));

var _jsxFileName = "/builds/sport1/libraries/universal-components/lib/components/Universal/Basic/FontelloIcon.js";

var _default = function _default(_ref) {
  var name = _ref.name,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["name"]);
  var glyph = (0, _Fontello.default)(name && name.toLowerCase());
  return _react.default.createElement(_Basic.Text, (0, _extends2.default)({
    noSelect: true,
    fontello: true
  }, rest, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 9
    }
  }), String.fromCharCode(glyph));
};

exports.default = _default;